import React from "react";
import { Box, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
import FileUpload from "./FileUpload";

const BasicFileUploadPage = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic File upload
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            title={'props - maxSizeMessage, variant(linear/circular),error, status, accept, onChange, multiple.'}
            value={"<FileUpload />"}
          >
            <FileUpload />
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicFileUploadPage;
